import styled from 'styled-components';

export const DatePickerWrapper = styled.div`
  .react-datepicker-popper {
    width: max-content;
    z-index: 1000000000000 !important;
  }
  
  .react-datepicker__input-container {
    .form-control, .custom-input {
      height: 34px !important;
    }
  }
  
  .react-datepicker__portal .react-datepicker__day-name, 
  .react-datepicker__portal .react-datepicker__day, 
  .react-datepicker__portal .react-datepicker__time-name {
    width: 25px !important;
    line-height: 25px !important;
  }
  
  .react-datepicker__month-container {
    .react-datepicker__month {
      height: 180px !important;
    }
  }
  
  .react-datepicker-wrapper {
    .form-control, .custom-input {
      height: 34px !important;
    }
  }

  .react-datepicker__children-container {
    display: initial;
    margin: 0;
    padding-right: 0;
    padding-left: 0;
  }
`;

export const ScheduleDataTableWrapper = styled.div`
  position: relative;
  .Polaris-DataTable__Cell--firstColumn {
    width: initial !important;
  }
  .Polaris-DataTable__Table tr td:last-child,
  .Polaris-DataTable__Table thead th:last-child {
    min-width: 117px;
    max-width: 117px;
    text-align: right;
    .Polaris-ButtonGroup {
      float: right; 
    }
  }
`;

export const StyledAutocompleteWrapper = styled.div`
  .Polaris-Connected__Item:not(.Polaris-Connected__Item--primary) {
    max-width: 50%;
  }
  
  .custom-autocomplete-prefix {
    height: 100%;
    border-radius: var(--p-border-radius-base) 0 0 var(--p-border-radius-base);
    border: 1px solid var(--p-border-subdued);
    border-top-color: var(--p-border-shadow);
    border-right: 0;
  }
  
  .Polaris-TextField {
    height: 100%;
  }
  
  .Polaris-TextField__Backdrop {
    ${(props) => props.noItems ? '' : 'border-left: 0;' }
    ${(props) => props.noItems ? '' : 'border-radius: 0 var(--p-border-radius-base) var(--p-border-radius-base) 0;' }
  }
`;

export const TableWrapper = styled.div`
  .Polaris-DataTable__Cell--firstColumn {
    width: inherit !important;
  }
  
  .Polaris-DataTable__Table thead tr {
    height: inherit;
  }
`;

export const HideHeaderWrapper = styled.div`
  .Polaris-DataTable__Table thead tr {
    height: inherit;
  }
  
  .Polaris-DataTable__Table thead tr th {
    padding: 0;
  }
`;
